"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { usePathname } from "next/navigation";
import type { CSSProperties } from "react";
import { useEffect, useState } from "react";
import { SHOP_IS_OPEN, SHOP_IS_PUBLIC } from "@/features/shop/shop-status";
import LanguageSwitch from "./language-switch";
type NavItem = {
  label: string;
  targetId?: string;
  href?: string;
  accent?: boolean;
};
const SHOP_NAV_ITEMS: readonly NavItem[] = SHOP_IS_OPEN && SHOP_IS_PUBLIC ? [{
  label: "Boutique",
  href: "/boutique"
}] : [];
const NAV_LEFT: readonly NavItem[] = [{
  label: "Accueil",
  targetId: "hero"
}, {
  label: "La marque",
  href: "/la-marque"
}, {
  label: "Nos réseaux",
  href: "/reseaux"
}] as const;
const NAV_RIGHT: readonly NavItem[] = [{
  label: "Où nous trouver",
  href: "/trouver"
}, ...SHOP_NAV_ITEMS, {
  label: "Distributeurs",
  href: "/distributeurs",
  accent: true
}];
const ALL_NAV: readonly NavItem[] = [{
  label: "Accueil",
  targetId: "hero",
  accent: false
}, {
  label: "La marque",
  href: "/la-marque",
  accent: false
}, {
  label: "Nos réseaux",
  href: "/reseaux",
  accent: false
}, {
  label: "Où nous trouver",
  href: "/trouver",
  accent: false
}, ...SHOP_NAV_ITEMS, {
  label: "Distributeurs",
  href: "/distributeurs",
  accent: true
}];
const COCKTAILS_NAV = [{
  label: "Moscow Mule",
  href: "/cocktails/moscow-mule"
}, {
  label: "Pink Lady",
  href: "/cocktails/pink-lady"
}, {
  label: "Gin Tonic",
  href: "/cocktails/gin-tonic"
}, {
  label: "Mojito",
  href: "/cocktails/mojito"
}, {
  label: "Pornstar Martini",
  href: "/cocktails/pornstar-martini"
}] as const;
const MENU_ACCENT_COLOR = "#c0271a";
const DEFAULT_LOGO_ACCENT = "#e7398d";
function CartelLogo(t0) {
  const $ = _c(18);
  const {
    accentColor,
    className: t1
  } = t0;
  const className = t1 === undefined ? "h-[clamp(56px,18vw,92px)] sm:h-[132px] lg:h-[152px]" : t1;
  const t2 = `w-auto object-contain ${className}`;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="#010202" d="M27.83,130.63s-6.94-1.06-9.12-13.38c-2.16-12.33,0-77.86,0-77.86,0,0,1.66-12.54,15.41-15.98l45.23-4.24s15.53-2.03,17.69,10.31c0,0,42.37-6.46,46.78-.69l.82-2.22,60.36-4.91v-10.39l44.31-2.93v11.47l44.92-1.13,4.77,2.4v-12.73l42.17-2.62-.6,70.29,18.89.07.56,33.77-2.51-.12s.42,9.54-1.87,12.53l10.91,4.7s-1.19,39.95-44.03,46.67c0,0-251.21,37.51-288.21,53.21-1.75.74-3.61,1.13-5.49,1.08-5.15-.14-13.63-2.22-10.01-14.89.14-.49.27-1.01.38-1.52l5.72-29.07s-25.26,3.31-17.91-25.74c0,0,6.38-16.89,20.8-26.06l.04-.03Z" />;
    t4 = <path fill="#fcfcfc" d="M61.24,60.61l25.52-1.93v-26.05s-.15-8.57-11.82-7.9c-11.65.69-39.42,4.5-39.42,4.5,0,0-10.42,3.74-10.58,11.6-.16,7.85.57,75.19.57,75.19,0,0-.56,9.44,16.72,5.43,17.27-4.01,35.52-7.73,35.52-7.73,0,0,9.22.51,8.27-12.29-.95-12.8.26-22.26.26-22.26l-24.65,4.36.15,15.2-11.17,1.5-.23-54.13,10.64-.94.18,15.44h.03Z" />;
    t5 = <path fill="#fcfcfc" d="M108.01,110.85c9.53-1.13,15.49-8.24,15.49-8.24l.23,5.57,22.46-1.86s.23-48.52,0-62.38c-.23-13.87-15.41-10.43-15.41-10.43,0,0-22.55,1.38-30.35,2.52s-8.32,9.16-8.32,9.16v13.43l22.44-1.81.16-6.53h7.62v10.8s-11.42,2.15-21.45,3.42c-10.02,1.28-8.71,8.01-8.71,8.01v32.17c2.02,7.39,6.34,7.3,15.87,6.16l-.02.02ZM114.61,77.97l7.18-1.23v14.93l-7.18.85v-14.55Z" />;
    t6 = <path fill="#fcfcfc" d="M152.66,105.37l.04-68.45s0-3.1-1.83-4.49l25.15-2.08v7.18s7.75-8.18,15.82-8.65c8.08-.48,10.6.81,12.78,6.89l.4,25.64-20.97.93.13-15.81-7.91.4.37,57.44-23.99.99Z" />;
    t7 = <path fill="#fcfcfc" d="M211.57,101.6l27.32-.44v-56.78h9.11l.15-11.71,2.07-4.25-11.13.36-.11-14.63-25.81,2.41s.77,2.09.85,3.18c.08,1.09-.04,11.15-.04,11.15l-6.48.07v15.14l5.74-.26v52.29s-.8,3.1-1.67,3.46Z" />;
    t8 = <path fill="#fcfcfc" d="M305.31,94.54v-18.47h-23.3l-.03,7.41-7.98.09-.08-11.95h30.88l-.93-36.94s-.78-9.37-9.48-9.15c-8.69.21-31.71.61-31.71.61,0,0-10.59,1.31-11.14,10.8-.56,9.47,0,51.83,0,51.83,0,0,8.58.03,11.14,6.2,0,0,16.79-3.25,19.58,6.6h16.32s5.99-1.02,6.72-7.06v.03ZM273.89,55.18v-11.91h7.61v11.91h-7.61Z" />;
    t9 = <path fill="#fcfcfc" d="M310.12,101.6l-1.33-81.18s-.71-6.3-1.38-6.45c-.66-.16,25.03-2.08,25.03-2.08v71.17l18.71.48v18.03h-41.03v.02Z" />;
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
    $[3] = t6;
    $[4] = t7;
    $[5] = t8;
    $[6] = t9;
  } else {
    t3 = $[0];
    t4 = $[1];
    t5 = $[2];
    t6 = $[3];
    t7 = $[4];
    t8 = $[5];
    t9 = $[6];
  }
  let t10;
  let t11;
  let t12;
  let t13;
  if ($[7] !== accentColor) {
    t10 = <path fill={accentColor} d="M43.83,214.04c-.67-3.77-1.65-13,2.05-23.43.45-1.3,1.46-2.31,2.72-2.74,6.8-2.27,30.21-11.62,41.67-35.43,13.5-28.05-8.81-31.11-8.81-31.11,0,0-27.73-4.78-52.85,17.25-25.12,22.03-11.62,32.59-8.65,32.46,2.99-.12,11.52-1.94,8.55-5.5-2.97-3.55-4.7-9.53,18.1-27.82,0,0,27.94-17.96,32.35,0,4.41,17.96-23.88,37.89-28.62,39.57-.2.07-.4-.14-.34-.37l11.04-38.52c.09-.31-.18-.6-.47-.53-2.95.73-14.76,3.76-15.6,5.73-.96,2.27-16.57,56.42-15.93,64.78.65,8.38-.59,10.78,5.24,11.38,3.61.37,6.56-1.22,8.28-2.47,1-.72,1.5-2.01,1.27-3.25h-.02Z" />;
    t11 = <path fill={accentColor} d="M262.7,107.41s.58-5.91,7.4-7.01c1.91-.31,3.93.29,5.19,1.84s1.68,3.82.71,7.77c0,0-1.08,5.02-8.12,5.25-7.05.22-5.18-7.84-5.18-7.84Z" />;
    t12 = <path fill={accentColor} d="M103.17,184.54c1.93-1.57,3.51-3.61,4.73-5.82l3.32-5.95c.07-.11.22-.09.24.03.29,1.47,1.55,7.05,4.39,7.93,3.28,1.02,7.73,3.44,16.37-9.52,1.72-2.52-.82,5.33,3.35,7.17,1.28.55,2.7.54,4.03.11l2.48-.78c1.05-.34,1.53-1.06,1.46-1.86-.26-3.45-.3-12.98,5.44-22.56,7.2-12,7.75-8.07,7.75-8.07,0,0-.6,7.75,3.26,7.76,3.86.02,4.79-4.37,4.79-4.37l2.29-8.05c.38-1.35.57-2.77.4-4.16-.31-2.5-1.72-5.4-7.03-3.28-1.48.58-2.77,1.59-3.77,2.85l-7.91,9.85s-.08,0-.08-.03l.34-9.41c0-.44-.34-.79-.77-.75-2.35.22-9.23.99-9.9,2.11-.8,1.35.14,23.5-12.96,33.81,0,0-4.31,1.26-1.89-9.31,2.02-8.8,5.31-16.32,6.37-18.59.19-.41.06-.91-.33-1.17-1.73-1.13-6.59-3.75-10.34-.61-.58.48-1.44.48-2.02,0-2.02-1.68-7.36-3.85-17.65,5.65,0,0-13.05,14.69-12.62,28.32.12,3.7,1.58,7.31,4.39,9.57,2.6,2.1,6.61,3.39,11.82-.84l.04-.02ZM99.78,173.83c-.3-1.11-.35-2.82.22-5.48,0,0,5.39-18.65,13.55-19.68,0,0,5.19-1.46,0,7.82-4.69,8.35-6.16,16.04-10.53,18.68-1.24.76-2.86.11-3.24-1.34Z" />;
    t13 = <path fill={accentColor} d="M188.38,161.03c.04-.11.18-.09.18,0,.2,1.94,1.44,9.84,8.07,9.21,0,0,8.86-.41,13.06-11,.05-.14.25-.14.29.02.34,1.92,2.11,8.18,10.34,8.48,8.46.3,11.47-8.98,12.1-11.41.03-.11.19-.1.2.02.28,1.8,1.61,7.16,7.75,7.81,7.27.78,12.48-7.41,13.63-10.88,0-.06.08-.04.09,0,.26,1.35,2.02,9.08,8.65,8.82,5.85-.23,9.36-4.9,10.5-6.71.21-.33.67-.4.96-.11,1.62,1.65,6.94,6.09,15.85,4.56,10.62-1.8,13.82-6.56,17.61-12.67.14-.23.45-.23.6,0,1.24,1.89,6.27,8.86,13.19,8.63,7.9-.27,24.19-5.12,31.79-24.47.14-.39-.02-.83-.38-.99l-3.58-1.73c-.5-.25-1.08-.11-1.42.35-3.37,4.56-20.97,27.36-26.91,13.07-.18-.44.06-.93.49-1.08,3.47-1.11,17.07-6.46,19.64-22.58.35-2.22-.03-4.56-1.29-6.39-1.68-2.43-5.15-4.6-12.22-2.17-4.39,1.5-8.38,4.15-11.61,7.62-3.62,3.9-7.86,10.08-8.51,18.17-.09,1.17-.29,2.32-.66,3.41-.54,1.54-1.42,3.54-2.62,4.27-.34.22-.77.06-.96-.31-.95-1.98-4.28-8.37-8.31-10.34-1.29-.62-2.49-1.42-3.55-2.4-2.11-1.99-4.31-5.09-1.22-7.68,1.4-1.16,3.3-1.5,4.99-.93,1.6.54,3.1,1.64,1.72,3.93-.37.6-.48,1.35-.24,2.02.59,1.78,2.23,4.39,6.22.45,0,0,3.74-3.58,1.79-8.25-.84-2.01-2.59-3.44-4.61-4.02-4.66-1.34-14.97-2.83-21.71,7.14,0,0-5.34,9.07,7.01,17.43,1.57,1.07,2.97,2.39,4.12,3.92,2.15,2.93,3.77,7.06-2.97,8.37,0,0-6.59,1.25-5.16-7.4.12-.71-.07-1.42-.55-1.94-1.04-1.13-3.11-2.73-5.61-1.15-1.09.69-1.84,1.86-2.2,3.16-.51,1.93-1.77,5.38-4.33,7.05-1.14.74-2.62.32-3.08-1-.55-1.54-.61-4.49,1.07-10.16l4.42-18.78s-4.7-5.65-12.02-1.27c0,0-4.06,30.92-13.09,33.16,0,0-2.91.82-.99-9.49,1.93-10.32,10-44.82,10-44.82,0,0,3.25-8.52-11.91-4.41l-6.16,28.76s-8.31-6.58-17.8,4.49c0,0-8.58,8.52-10.11,21.6,0,0-2.68,8.92-6.84,9.9,0,0-3.94,2.43-.52-13.61l3.41-16.04s-1.98-4.19-10.42,0c0,0-9.76-6.58-19.78,5.67,0,0-19.42,27.8-4.92,35.93,0,0,11.99,7.11,18.49-11.23l.02.03ZM320.9,133.48c-.29-1.5.07-3.28.57-4.83.7-2.15,1.82-4.12,3.11-5.93,4.92-6.82,6.75-5.17,7.25-4.32.11.18.16.4.16.62-.23,8.54-8.38,13.6-10.47,14.76-.24.14-.57,0-.62-.3ZM220.93,155.87c-.29-1.11-.35-2.82.22-5.48,0,0,5.39-18.65,13.55-19.68,0,0,5.19-1.46,0,7.82-4.69,8.35-6.16,16.04-10.53,18.68-1.24.76-2.86.11-3.24-1.34ZM176.7,161.71c-.29-1.11-.35-2.82.22-5.48,0,0,5.39-18.65,13.55-19.68,0,0,5.19-1.46,0,7.82-4.68,8.35-6.15,16.04-10.53,18.68-1.24.76-2.86.11-3.24-1.34Z" />;
    $[7] = accentColor;
    $[8] = t10;
    $[9] = t11;
    $[10] = t12;
    $[11] = t13;
  } else {
    t10 = $[8];
    t11 = $[9];
    t12 = $[10];
    t13 = $[11];
  }
  let t14;
  if ($[12] !== t10 || $[13] !== t11 || $[14] !== t12 || $[15] !== t13 || $[16] !== t2) {
    t14 = <svg viewBox="0 0 372.07 236.98" aria-hidden="true" className={t2}>{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}</svg>;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
    $[15] = t13;
    $[16] = t2;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  return t14;
}
export default function Header() {
  const $ = _c(92);
  const [open, setOpen] = useState(false);
  const [logoAccent, setLogoAccent] = useState(DEFAULT_LOGO_ACCENT);
  const [isOnMap, setIsOnMap] = useState(false);
  const pathname = usePathname();
  let t0;
  let t1;
  if ($[0] !== pathname) {
    t0 = () => {
      if (pathname === "/trouver") {
        setIsOnMap(true);
        return;
      }
      setIsOnMap(false);
      let obs = null;
      let rafId = 0;
      let attempts = 0;
      const attachObserver = () => {
        const trouver = document.getElementById("trouver");
        if (!trouver) {
          attempts = attempts + 1;
          attempts;
          if (attempts < 120) {
            rafId = window.requestAnimationFrame(attachObserver);
          }
          return;
        }
        const rect = trouver.getBoundingClientRect();
        const viewportH = window.innerHeight || document.documentElement.clientHeight;
        const overlapTop = Math.max(rect.top, 0);
        const overlapBottom = Math.min(rect.bottom, viewportH);
        const overlap = Math.max(0, overlapBottom - overlapTop);
        const ratio = rect.height > 0 ? overlap / rect.height : 0;
        setIsOnMap(ratio >= 0.45);
        obs = new IntersectionObserver(t2 => {
          const [entry] = t2;
          return setIsOnMap(!!entry?.isIntersecting);
        }, {
          threshold: 0.45
        });
        obs.observe(trouver);
      };
      attachObserver();
      return () => {
        if (rafId) {
          window.cancelAnimationFrame(rafId);
        }
        obs?.disconnect();
      };
    };
    t1 = [pathname];
    $[0] = pathname;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[3] !== pathname) {
    t2 = () => {
      if (pathname !== "/") {
        setLogoAccent(pathname === "/inscription-lancement" ? "#e8620a" : DEFAULT_LOGO_ACCENT);
        return;
      }
      const scrollRoot = document.getElementById("home-scroll-root");
      const sections = Array.from(document.querySelectorAll("[data-logo-accent]"));
      if (!sections.length) {
        return;
      }
      const updateAccent = () => {
        const rootRect = scrollRoot?.getBoundingClientRect();
        const viewportCenter = rootRect ? rootRect.top + rootRect.height * 0.5 : window.innerHeight * 0.5;
        let bestSection = null;
        let bestDistance = Number.POSITIVE_INFINITY;
        for (const section of sections) {
          const rect_0 = section.getBoundingClientRect();
          const sectionCenter = rect_0.top + rect_0.height / 2;
          const distance = Math.abs(sectionCenter - viewportCenter);
          if (distance < bestDistance) {
            bestDistance = distance;
            bestSection = section;
          }
        }
        const nextAccent = bestSection?.dataset.logoAccent ?? DEFAULT_LOGO_ACCENT;
        setLogoAccent(current => current === nextAccent ? current : nextAccent);
      };
      updateAccent();
      scrollRoot?.addEventListener("scroll", updateAccent, {
        passive: true
      });
      window.addEventListener("resize", updateAccent);
      return () => {
        scrollRoot?.removeEventListener("scroll", updateAccent);
        window.removeEventListener("resize", updateAccent);
      };
    };
    t3 = [pathname];
    $[3] = pathname;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  const scrollToSection = _temp;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      fontFamily: "var(--cp-font-anton)"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== pathname) {
    t5 = NAV_LEFT.map(t6 => {
      const {
        label,
        targetId,
        href
      } = t6;
      return <Link key={label} href={(href || "/") as any} onClick={event => {
        if (href) {
          return;
        }
        if (pathname !== "/") {
          return;
        }
        event.preventDefault();
        if (targetId) {
          scrollToSection(targetId);
        }
      }} className="uppercase transition-colors duration-200 hover:text-white">{label}</Link>;
    });
    $[7] = pathname;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <nav aria-label="Navigation principale" className="hidden items-center gap-8 text-[18px] tracking-[0.22em] text-white/60 sm:flex" style={t4}>{t5}</nav>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setOpen(_temp2);
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = open ? "Fermer le menu" : "Ouvrir le menu";
  const t9 = `block h-px w-5 bg-white transition-all duration-300 ${open ? "translate-y-[6px] rotate-45" : ""}`;
  let t10;
  if ($[12] !== t9) {
    t10 = <span className={t9} />;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const t11 = `block h-px bg-white transition-all duration-300 ${open ? "w-0 opacity-0" : "w-5 opacity-100"}`;
  let t12;
  if ($[14] !== t11) {
    t12 = <span className={t11} />;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  const t13 = `block h-px w-5 bg-white transition-all duration-300 ${open ? "-translate-y-[6px] -rotate-45" : ""}`;
  let t14;
  if ($[16] !== t13) {
    t14 = <span className={t13} />;
    $[16] = t13;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== open || $[19] !== t10 || $[20] !== t12 || $[21] !== t14 || $[22] !== t8) {
    t15 = <button type="button" className="relative z-[2002] flex h-8 w-8 flex-col items-center justify-center gap-[5px] sm:hidden" onClick={t7} aria-label={t8} aria-expanded={open} aria-controls="mobile-menu">{t10}{t12}{t14}</button>;
    $[18] = open;
    $[19] = t10;
    $[20] = t12;
    $[21] = t14;
    $[22] = t8;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== pathname) {
    t16 = event_0 => {
      if (pathname !== "/") {
        return;
      }
      event_0.preventDefault();
      scrollToSection("hero");
    };
    $[24] = pathname;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  const t17 = `absolute bottom-0 left-1/2 z-10 -translate-x-1/2 translate-y-1/2 transition-all duration-500 ease-out will-change-transform ${isOnMap ? "opacity-0 scale-90 pointer-events-none sm:opacity-100 sm:scale-100 sm:pointer-events-auto" : "opacity-100 scale-100"}`;
  let t18;
  if ($[26] !== logoAccent) {
    t18 = <CartelLogo accentColor={logoAccent} />;
    $[26] = logoAccent;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== t16 || $[29] !== t17 || $[30] !== t18) {
    t19 = <Link href="/" onClick={t16} className={t17} aria-label={"Retour \xE0 la hero section"}>{t18}</Link>;
    $[28] = t16;
    $[29] = t17;
    $[30] = t18;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== pathname) {
    t20 = event_1 => {
      if (pathname !== "/") {
        return;
      }
      event_1.preventDefault();
      scrollToSection("hero");
    };
    $[32] = pathname;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  const t21 = `absolute right-[88px] top-1/2 z-10 -translate-y-1/2 sm:hidden transition-all duration-500 ease-out will-change-transform ${isOnMap ? "opacity-100 translate-x-0 pointer-events-auto" : "opacity-0 translate-x-3 pointer-events-none"}`;
  let t22;
  if ($[34] !== logoAccent) {
    t22 = <CartelLogo accentColor={logoAccent} className="h-[34px] sm:h-[38px] lg:h-[42px]" />;
    $[34] = logoAccent;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== t20 || $[37] !== t21 || $[38] !== t22) {
    t23 = <Link href="/" onClick={t20} className={t21} aria-label={"Retour \xE0 la hero section"}>{t22}</Link>;
    $[36] = t20;
    $[37] = t21;
    $[38] = t22;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = {
      fontFamily: "var(--cp-font-anton)"
    };
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  let t26;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="flex items-center gap-[3px]" aria-hidden="true">{[1, 2, 3, 4, 5].map(_temp3)}</div>;
    t26 = <div className="h-4 w-px bg-[#e8620a]/15" aria-hidden="true" />;
    $[41] = t25;
    $[42] = t26;
  } else {
    t25 = $[41];
    t26 = $[42];
  }
  let t27;
  if ($[43] !== pathname) {
    t27 = NAV_RIGHT.map(t28 => {
      const {
        label: label_0,
        targetId: targetId_0,
        href: href_0,
        accent
      } = t28;
      return <Link key={label_0} href={(href_0 || "/") as any} onClick={event_2 => {
        if (href_0) {
          return;
        }
        if (pathname !== "/") {
          return;
        }
        event_2.preventDefault();
        if (targetId_0) {
          scrollToSection(targetId_0);
        }
      }} className={`uppercase transition-colors duration-200 ${accent ? "hover:text-[var(--menu-accent)]" : "hover:text-white"}`} style={accent ? {
        "--menu-accent": MENU_ACCENT_COLOR
      } as CSSProperties : undefined}>{label_0}</Link>;
    });
    $[43] = pathname;
    $[44] = t27;
  } else {
    t27 = $[44];
  }
  let t28;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <LanguageSwitch className="tracking-normal" />;
    $[45] = t28;
  } else {
    t28 = $[45];
  }
  let t29;
  if ($[46] !== t27) {
    t29 = <nav aria-label="Actions principales" className="ml-auto hidden items-center gap-6 text-[18px] tracking-[0.22em] text-white/60 sm:flex" style={t24}>{t25}{t26}{t27}{t28}</nav>;
    $[46] = t27;
    $[47] = t29;
  } else {
    t29 = $[47];
  }
  let t30;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <LanguageSwitch className="ml-auto sm:hidden" />;
    $[48] = t30;
  } else {
    t30 = $[48];
  }
  let t31;
  if ($[49] !== t15 || $[50] !== t19 || $[51] !== t23 || $[52] !== t29 || $[53] !== t6) {
    t31 = <header className="fixed top-0 inset-x-0 z-[2000]"><div className="relative flex h-16 items-center overflow-visible border-b border-[#e8620a]/15 bg-[#0d0a07] px-5 sm:h-20 sm:px-10">{t6}{t15}{t19}{t23}{t29}{t30}</div></header>;
    $[49] = t15;
    $[50] = t19;
    $[51] = t23;
    $[52] = t29;
    $[53] = t6;
    $[54] = t31;
  } else {
    t31 = $[54];
  }
  const t32 = `fixed inset-0 z-[2001] sm:hidden transition-opacity duration-500 ${open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`;
  let t33;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <div className="absolute inset-0 bg-[#0d0a07]" />;
    $[55] = t33;
  } else {
    t33 = $[55];
  }
  let t34;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = () => setOpen(false);
    $[56] = t34;
  } else {
    t34 = $[56];
  }
  let t35;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <button type="button" onClick={t34} className="absolute right-5 top-5 z-[2003] border border-white/15 px-3 py-2 text-[10px] uppercase tracking-[0.24em] text-white/70 transition-colors duration-200 hover:text-white" style={{
      fontFamily: "var(--cp-font-anton)"
    }} aria-label="Fermer le menu">Fermer</button>;
    $[57] = t35;
  } else {
    t35 = $[57];
  }
  const t36 = `absolute left-5 top-0 w-px bg-white/10 transition-all duration-700 ${open ? "h-full" : "h-0"}`;
  const t37 = open ? "200ms" : "0ms";
  let t38;
  if ($[58] !== t37) {
    t38 = {
      transitionDelay: t37
    };
    $[58] = t37;
    $[59] = t38;
  } else {
    t38 = $[59];
  }
  let t39;
  if ($[60] !== t36 || $[61] !== t38) {
    t39 = <div className={t36} style={t38} />;
    $[60] = t36;
    $[61] = t38;
    $[62] = t39;
  } else {
    t39 = $[62];
  }
  let t40;
  if ($[63] !== open || $[64] !== pathname) {
    t40 = ALL_NAV.map((t41, i) => {
      const {
        label: label_1,
        targetId: targetId_1,
        href: href_1,
        accent: accent_0
      } = t41;
      return <div key={label_1} className="overflow-hidden border-b border-white/5 py-1"><Link href={(href_1 || "/") as any} onClick={event_3 => {
          setOpen(false);
          if (href_1) {
            return;
          }
          if (pathname === "/") {
            event_3.preventDefault();
            if (targetId_1) {
              window.setTimeout(() => scrollToSection(targetId_1), 0);
            }
          }
        }} className={`block py-4 text-[2.4rem] uppercase leading-none tracking-[0.04em] transition-all duration-300 ${accent_0 ? "text-[color:rgb(228_0_124_/_0.7)] hover:text-[var(--menu-accent)]" : "text-white/70 hover:text-white"} ${open ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`} style={{
          "--menu-accent": MENU_ACCENT_COLOR,
          fontFamily: "var(--cp-font-anton)",
          transitionDuration: "500ms",
          transitionDelay: open ? `${i * 90 + 80}ms` : "0ms"
        } as CSSProperties}>{label_1}</Link></div>;
    });
    $[63] = open;
    $[64] = pathname;
    $[65] = t40;
  } else {
    t40 = $[65];
  }
  let t41;
  if ($[66] !== t40) {
    t41 = <nav className="flex flex-col" aria-label="Menu mobile">{t40}</nav>;
    $[66] = t40;
    $[67] = t41;
  } else {
    t41 = $[67];
  }
  const t42 = `mt-8 transition-all duration-500 ${open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`;
  const t43 = open ? `${ALL_NAV.length * 90 + 120}ms` : "0ms";
  let t44;
  if ($[68] !== t43) {
    t44 = {
      transitionDelay: t43
    };
    $[68] = t43;
    $[69] = t44;
  } else {
    t44 = $[69];
  }
  let t45;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <p className="mb-3 text-[9px] tracking-[0.35em] text-[#e8620a]/50 uppercase" style={{
      fontFamily: "var(--cp-font-anton)"
    }}>Nos cocktails</p>;
    $[70] = t45;
  } else {
    t45 = $[70];
  }
  let t46;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <div className="flex flex-wrap gap-x-4 gap-y-2">{COCKTAILS_NAV.map(t47 => {
        const {
          label: label_2,
          href: href_2
        } = t47;
        return <Link key={label_2} href={href_2} onClick={() => setOpen(false)} className="text-[1rem] uppercase tracking-[0.1em] text-white/50 hover:text-white transition-colors duration-200" style={{
          fontFamily: "var(--cp-font-barlow-condensed)"
        }}>{label_2}</Link>;
      })}</div>;
    $[71] = t46;
  } else {
    t46 = $[71];
  }
  let t47;
  if ($[72] !== t42 || $[73] !== t44) {
    t47 = <div className={t42} style={t44}>{t45}{t46}</div>;
    $[72] = t42;
    $[73] = t44;
    $[74] = t47;
  } else {
    t47 = $[74];
  }
  const t48 = `mt-10 transition-all duration-500 ${open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`;
  const t49 = open ? `${ALL_NAV.length * 90 + 200}ms` : "0ms";
  let t50;
  if ($[75] !== t49) {
    t50 = {
      transitionDelay: t49
    };
    $[75] = t49;
    $[76] = t50;
  } else {
    t50 = $[76];
  }
  let t51;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = <p className="text-[9px] tracking-[0.35em] text-white/20 uppercase" style={{
      fontFamily: "var(--cp-font-anton)"
    }}>Cartel Paradise — 2026</p>;
    $[77] = t51;
  } else {
    t51 = $[77];
  }
  let t52;
  if ($[78] !== t48 || $[79] !== t50) {
    t52 = <div className={t48} style={t50}>{t51}</div>;
    $[78] = t48;
    $[79] = t50;
    $[80] = t52;
  } else {
    t52 = $[80];
  }
  let t53;
  if ($[81] !== t41 || $[82] !== t47 || $[83] !== t52) {
    t53 = <div className="relative flex h-full flex-col justify-center px-10 pb-16">{t41}{t47}{t52}</div>;
    $[81] = t41;
    $[82] = t47;
    $[83] = t52;
    $[84] = t53;
  } else {
    t53 = $[84];
  }
  let t54;
  if ($[85] !== t32 || $[86] !== t39 || $[87] !== t53) {
    t54 = <div id="mobile-menu" className={t32}>{t33}{t35}{t39}{t53}</div>;
    $[85] = t32;
    $[86] = t39;
    $[87] = t53;
    $[88] = t54;
  } else {
    t54 = $[88];
  }
  let t55;
  if ($[89] !== t31 || $[90] !== t54) {
    t55 = <>{t31}{t54}</>;
    $[89] = t31;
    $[90] = t54;
    $[91] = t55;
  } else {
    t55 = $[91];
  }
  return t55;
}
function _temp3(n) {
  return <svg key={n} width="9" height="9" viewBox="0 0 12 12" fill="none"><path d="M6 0.5L7.4 4.4H11.5L8.2 6.8L9.5 10.7L6 8.3L2.5 10.7L3.8 6.8L0.5 4.4H4.6L6 0.5Z" fill="rgba(232,98,10,0.45)" strokeWidth="0.8" /></svg>;
}
function _temp2(o) {
  return !o;
}
function _temp(sectionId) {
  const section_0 = document.getElementById(sectionId);
  if (!section_0) {
    return;
  }
  section_0.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });
}